import { useContext } from 'react';
import { TToolTipAutoShowContext, ToolTipAutoShowContext } from './tooltip-auto-show';

function useToolTipAutoShow<T extends string>() {
  const context = useContext(ToolTipAutoShowContext);
  if (context === undefined) {
    throw new Error('useSignedInContext must be used within a SignedInStatusContextProvider');
  }
  return context as TToolTipAutoShowContext<T>;
}

export { useToolTipAutoShow };
